"use client"

import { useEffect, useState } from "react"

/**
 * Hook used for watching window size changes
 *
 * @returns {width: number, height: number}
 */
const useWindowSize = () => {
  // initial state
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  })

  // on component render add event listener for window size change
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // add event listener
    window.addEventListener("resize", handleResize)
    handleResize()

    // cleanup on unmount
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // return the values
  return windowSize
}

export { useWindowSize }
